import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import { withStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "assets/css/form-auto.css";
import {} from "assets/jss/material-dashboard-react.js";
import api from "axios.js";
import axios from "axios";
import AssociationList from "components/AssociationList";
import CustomTabs from "components/CustomTabs/CustomTabs";
import MaterialTable from "components/MaterialTable.js";
import Form from "components/MuiJsonForm";
import RowGenerateFile from "components/RowGenerateFile";
import PubSub from "pubsub-js";
import queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Actions from "redux/actions";
import {
  dossierAppartColumns,
  fichierColumns,
  quitanceColumns,
} from "utils/columns";
import downloadFile from "utils/downloadFile";
import fileDialog from "utils/fileDialog";
import { fichierSchema, locataireSchema } from "utils/schemas";

class FormEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      formData: {},
      initLoad: true,
      formDataDossier_New: { data: {} },
    };
    this.dispatch = this.props.dispatch;
    this.isNew = props.match.params.id === "new";
    this.edit = props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    this.cancelSources = new Set();
    this.timeouts = new Set();
    this.subs = [];
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  loadData = () => {
    this.isNew = this.props.match.params.id === "new";
    this.edit = this.props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    this.cancelAllRequests("LocataireEditor remount");
    this.clearTimeouts();
    let action = [];
    if (!this.state.initLoad)
      this.updateState({
        loading: true,
        formData: {},
        initLoad: true,
        formDataDossier_New: { data: {} },
      });
    const locataireSource = this.createCancelSource();
    action.push(
      this.trackPromise(
        this.dispatch(
          Actions.getLocataire(this.props.match.params.id, {
            cancelToken: locataireSource.token,
          })
        ),
        locataireSource
      )
    );
    this.addTimeout(() => {
      if (!this._isMounted) return;
      if (!this.isNew) {
        const appartSource = this.createCancelSource();
        this.trackPromise(
          this.dispatch(Actions.getAppartements({ cancelToken: appartSource.token })),
          appartSource
        );
      } else {
        this.trackPromise(this.dispatch(Actions.getLocataire()), undefined);
      }
    }, 100);
    const variablesSource = this.createCancelSource();
    action.push(
      this.trackPromise(
        this.dispatch(Actions.getVariables({ cancelToken: variablesSource.token })),
        variablesSource
      )
    );
    Promise.all(action)
      .catch(() => null)
      .finally(() => this.updateState({ loading: false, initLoad: false }));
  };

  componentWillUnmount() {
    this._isMounted = false;
    this.clearTimeouts();
    this.cancelAllRequests("LocataireEditor unmounted");
    this.unsubscribeAll();
  }

  componentDidUpdate(prevProps, prevState) {
    this.isNew = this.props.match.params.id === "new";
    this.edit = this.props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    if (this.props.match.params !== prevProps.match.params) {
      this.loadData();
    }
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  addTimeout = (cb, delay = 0) => {
    const id = setTimeout(() => {
      this.timeouts.delete(id);
      cb();
    }, delay);
    this.timeouts.add(id);
    return id;
  };

  clearTimeouts = () => {
    this.timeouts.forEach((id) => clearTimeout(id));
    this.timeouts.clear();
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  unsubscribeAll = () => {
    this.subs.forEach((token) => PubSub.unsubscribe(token));
    this.subs = [];
  };

  onSubmit = (form) => {
    if (this.readOnly) return;
    const { personal, secondaire, isMineur, ...rest } = form.formData;
    const body = { ...personal, ...secondaire, ...isMineur, ...rest };
    if (!body.secondTitulaire) body.autreNom = null;
    this.updateState({ loading: true });
    return (
      this.isNew
        ? this.dispatch(Actions.createLocataire(body))
        : this.dispatch(Actions.setLocataire(this.props.match.params.id, body))
    ).then((rep) => {
      PubSub.notif({
        txt: this.isNew
          ? "Votre locataire à été crée avec succes."
          : "Vos modifications ont été prises en compte.",
        color: "success",
        icon: "save",
      });
      this.updateState({ loading: false });
      if (this.isNew)
        this.props.history.push(
          queryString.parse(this.props.location.search).oncreate ||
            `/locataires/${rep.payload.id}`
        );
    });
  };

  render() {
    const c = this.props.classes;
    const { locataire, canDelete } = this.props;
    return (
      <div className={c.container}>
        <CustomTabs
          initTab={queryString.parse(this.props.location.search).tab}
          title={
            this.state.loading
              ? "Chargement en cours..."
              : (!this.isNew
                  ? locataire.nom + " " + locataire.prenom
                  : "Nouveau Locataire"
                ).toUpperCase()
          }
          headerColor="info"
          rigthBtn={
            !this.isNew && {
              display: !this.edit,
              icon: "create",
              onClick: (_) =>
                this.props.history.push(this.props.match.url + "/edit"),
            }
          }
          tabs={[
            {
              tabName: "Details",
              tabIcon: "assignment_ind",
              tabContent: (
                <Form
                  initLoad={this.state.initLoad}
                  loading={this.state.loading}
                  readOnly={this.readOnly}
                  {...locataireSchema(
                    this.props.locataire,
                    this.readOnly,
                    this.isNew
                  )}
                  onChange={({ formData }) => this.updateState({ formData })}
                  formData={this.state.formData}
                  onSubmit={this.onSubmit}
                  onError={() => null}
                  removeEditOnSubmit
                />
              ),
            },
            {
              tabName: "Dossiers",
              tabIcon: "home",
              tabContent: (
                <AssociationList
                  title={`Dossier${
                    ((locataire || {}).dossiers || []).length > 1 ? "s" : ""
                  } en cours`}
                  data={(locataire || {}).dossiers || []}
                  columns={dossierAppartColumns}
                  onDetails={(locat) =>
                    this.props.history.push("/Dossiers/" + locat.id)
                  }
                  detailTxt="Voir les details du dossier"
                  actions={[
                    {
                      icon: "edit",
                      tooltip: "Editer le dossier",
                      onClick: (event, rowData) =>
                        this.props.history.push(
                          "/Dossiers/" + rowData.id + "/edit"
                        ),
                    },
                  ]}
                  topRightButtonTxt="Nouveau Dossier"
                  topRightDialogWidth="90%"
                  onTopRightButtonFn={(_) =>
                    this.props.history.push(
                      "/Dossiers/new?relatedTenant=" + locataire.id
                    )
                  }
                  noDataTxt="Aucun dossier en cours."
                  removeTxt="Clore le dossier"
                  onRemove={(_, row) =>
                    this.dispatch(
                      Actions.removeTenant(row.appartement.id, locataire.id)
                    )
                  }
                />
              ),
            },
            {
              tabName: "Fichiers",
              tabIcon: "description",
              tabContent: (
                <>
                  <h3>{`Fichier${
                    ((this.props.locataire || {}).Fichiers || []).length > 1
                      ? "s"
                      : ""
                  } lié au locataire`}</h3>
                  <AssociationList
                    data={(this.props.locataire || {}).Fichiers || []}
                    noDataTxt="Aucune fichier lié au locataire."
                    topRightButtonTxt="Ajouter un fichier"
                    onTopRightButton={(close) => (
                      <Form
                        style={{ width: "100%" }}
                        formData={this.state.newFileFormData}
                        {...fichierSchema(
                          {},
                          (data) => this.updateState({ newFileFormData: data }),
                          true,
                          false
                        )}
                        onSubmit={({ formData: { data } }) => {
                          this.dispatch(
                            Actions.addFichierLocataire(
                              this.props.match.params.id,
                              data
                            )
                          ).then(close);
                        }}
                        onError={() => null}
                      />
                    )}
                    columns={fichierColumns}
                    actions={[
                      {
                        icon: "get_app",
                        tooltip: "Télécharger le fichier",
                        onClick: (event, rowData) =>
                          downloadFile(
                            rowData.url,
                            `${locataire.nom} ${locataire.prenom}_${rowData.nom}.${rowData.extention}`
                          ),
                      },
                      {
                        icon: "publish",
                        tooltip: "Changer de fichier",
                        onClick: (event, rowData) =>
                          fileDialog("url").then((fd) =>
                            this.dispatch(Actions.setFichier(rowData.id, fd))
                          ),
                      },
                      canDelete && {
                        icon: "delete",
                        tooltip: "supprimer le fichier",
                        onClick: (event, rowData) =>
                          PubSub.confirm({
                            title: "Supprimer le fichier ?",
                            subtitle: "Cette action est irreversible.",
                            onAgree: (_) =>
                              this.dispatch(Actions.deleteFichier(rowData.id)).then(
                                (_) => this.loadData()
                              ),
                          }),
                      },
                    ]}
                  />
                  {(locataire || {}).dossiers.map((dossier, l) => (
                    <RowGenerateFile
                      key={dossier.id}
                      title={`Dossier n°${l + 1}: Etiquette de locataire`}
                      generateUrl={`Dossier/${dossier.id}/etiquetteLocataire/generate`}
                      generateName="Etiquette_locataire.docx"
                    />
                  ))}
                  {(this.props.quitances || []).some(
                    (q) => q.LocataireId === (locataire || {}).id
                  ) && (
                    <ExpansionPanel>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                        <h4>Quitances</h4>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails className="col">
                        <MaterialTable
                          title=""
                          isLoading={!(this.props.quitances && locataire)}
                          columns={quitanceColumns}
                          actions={[
                            {
                          icon: "assignment_returned",
                          tooltip: "Générer la quitance",
                          onClick: (event, rowData) =>
                                api
                                  .get(`Quitance/${rowData.id}/generate`)
                                  .then((rep) =>
                                    downloadFile(
                                      rep.data.generated,
                                      "Quitance.docx"
                                    )
                                  ),
                            },
                          ]}
                          data={(this.props.quitances || [])
                            .filter(
                              (q) => q.LocataireId === (locataire || {}).id
                            )
                            .sort(
                              (a, b) =>
                                new Date(a.date).getTime() -
                                new Date(b.date).getTime()
                            )}
                          onRowClick={(_) => null}
                          options={{
                            toolbar: true,
                            header: true,
                            filtering: false,
                            actionsColumnIndex: -1,
                          }}
                        />
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  )}
                </>
              ),
            },
          ].filter((t) => !this.isNew || t.tabName === "Details")}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    marginTop: 30,
  },
  formCard: {
    margin: "auto",
  },
});

const mapStateToProps = (state) => {
  const locataire = state.reducer.locataire || {};
  locataire.dossiers = (locataire.locations || []).map((loc) => ({
    ...loc.Dossier,
    appartement: { ...loc },
    locataire,
  }));
  return {
    locataire,
    appartement: state.reducer.appartement,
    locataires: state.reducer.locataires,
    variables: state.reducer.variables,
    canDelete: state.reducer.canDelete,
    quitances: state.reducer.quitances,
  };
};
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormEditor))
);
